import { useEffect, useState } from 'react';

interface ResponsiveBreakpoints {
  mobile: number;
  tablet: number;
  desktop: number;
}

const DEFAULT_BREAKPOINTS: ResponsiveBreakpoints = {
  mobile: 768,
  tablet: 1024,
  desktop: 1280,
};

export const useResponsiveLayout = (breakpoints: Partial<ResponsiveBreakpoints> = {}) => {
  const bp = { ...DEFAULT_BREAKPOINTS, ...breakpoints };
  
  const [windowWidth, setWindowWidth] = useState(() => {
    if (typeof window !== 'undefined') {
      return window.innerWidth;
    }
    return bp.desktop; // Default for SSR
  });

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const isMobile = windowWidth < bp.mobile;
  const isTablet = windowWidth >= bp.mobile && windowWidth < bp.tablet;
  const isDesktop = windowWidth >= bp.desktop;
  const isTabletOrMobile = windowWidth < bp.tablet;

  return {
    windowWidth,
    isMobile,
    isTablet,
    isDesktop,
    isTabletOrMobile,
    breakpoints: bp,
  };
};